import { SourceEnum } from './source-enum'

export interface PluginInterface {
  /**
   * 应用名称(页面显示用)
   */
  label?: string
  /**
   * 应用唯一标识
   */
  name?: string
  /**
   * 应用图标
   */
  icon?: string | null
  /**
   * 应用描述
   */
  description?: string
  /**
   * 应用来源
   */
  source?: SourceEnum
  weight?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class Plugin implements PluginInterface {
  /**
   * 应用名称(页面显示用)
   */
  label?: string
  /**
   * 应用唯一标识
   */
  name?: string
  /**
   * 应用图标
   */
  icon?: string | null
  /**
   * 应用描述
   */
  description?: string
  /**
   * 应用来源
   */
  source?: SourceEnum
  weight?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: PluginInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      label: _label,
      name: _name,
      icon: _icon,
      description: _description,
      source: _source,
      weight: _weight,
      id: _id,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.label = _label
    this.name = _name
    this.icon = _icon
    this.description = _description
    this.source = _source
    this.weight = _weight
    this.id = _id
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
